module.exports = __webpack_public_path__ + "img/cover.7aa46201.jpeg";